import { JSX } from "react";

import { IconProps } from "@/@types/general.ts";

const IconStar = (props: IconProps): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10" {...props}>
    <path
      d="M5.17231 7.45049L7.14244 8.69869C7.39428 8.85824 7.70694 8.62094 7.63222 8.32698L7.063 6.08782C7.04697 6.02546 7.04887 5.95983 7.06848 5.8985C7.08809 5.83716 7.12461 5.78261 7.17384 5.74111L8.94053 4.27066C9.17267 4.07745 9.05285 3.69219 8.75461 3.67284L6.44743 3.5231C6.38528 3.51866 6.32568 3.49666 6.27555 3.45966C6.22543 3.42265 6.18685 3.37217 6.1643 3.31409L5.30382 1.14718C5.28043 1.08553 5.23884 1.03246 5.18458 0.995008C5.13031 0.957557 5.06594 0.9375 5 0.9375C4.93407 0.9375 4.86969 0.957557 4.81543 0.995008C4.76116 1.03246 4.71957 1.08553 4.69618 1.14718L3.8357 3.31409C3.81315 3.37217 3.77457 3.42265 3.72445 3.45966C3.67432 3.49666 3.61472 3.51866 3.55258 3.5231L1.24539 3.67284C0.947147 3.69219 0.827332 4.07745 1.05947 4.27066L2.82616 5.74111C2.87539 5.78261 2.91192 5.83716 2.93152 5.8985C2.95113 5.95983 2.95303 6.02546 2.937 6.08782L2.40912 8.16439C2.31944 8.51715 2.69465 8.80191 2.99685 8.61044L4.82769 7.45049C4.87919 7.41771 4.93896 7.4003 5 7.4003C5.06104 7.4003 5.12082 7.41771 5.17231 7.45049V7.45049Z"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default IconStar;
